import * as React from 'react';
import { VideoAttachment as VideoAttachmentT } from '../../../typedefs/store';
import styled from 'styled-components';
import * as YoutubeIcon from 'react-icons/lib/io/social-youtube';

interface Props {
    attachment: VideoAttachmentT;
}

interface State {}

class VideoAttachment extends React.Component<Props, State> {
    viewVideo = () => {
        if (this.props.attachment.videoUrl) window.open(this.props.attachment.videoUrl, 'new');
    };

    render() {
        const { thumbnail, title } = this.props.attachment;
        return (
            <Wrapper className="conversations-attachment conversations-attachment-video" onClick={this.viewVideo}>
                <ImageWrapper>
                    <PlayButton>
                        <YoutubeIcon size={36} />
                    </PlayButton>
                    <img src={thumbnail} />
                </ImageWrapper>
                <Title>{title}</Title>
            </Wrapper>
        );
    }
}

export default VideoAttachment;

const Wrapper = styled.div`
    cursor: pointer;
    img {
        max-width: 100%;
    }
`;

const ImageWrapper = styled.div`position: relative;`;
const PlayButton = styled.div`
    position: absolute;
    top: calc(50% - 18px);
    left: calc(50% - 20px);
    width: 40px;
    height: 36px;
    text-align: center;
    color: white;
`;
const Title = styled.div`margin-top: 5px;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/VideoAttachment.tsx